import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const DisplayHtmlContent: React.FC = props => {
  const { children } = props;
  return <div>{ReactHtmlParser(children as string)}</div>;
};

export default DisplayHtmlContent;
